// extracted by mini-css-extract-plugin
export default {"SwitchButton":"SwitchButton_SwitchButton__OFM4+","in":"SwitchButton_in__mTKTN","on":"SwitchButton_on__Ni0lR","disabled":"SwitchButton_disabled__Pf4Ju"};